import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import { getImagePath } from '../utils/imageOptimization';
import '../styles/image-modal.css';

function ImageModal({ photo, onClose, onNext, onPrev, folder = 'photography' }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      switch (e.key) {
        case 'Escape':
          onClose();
          break;
        case 'ArrowLeft':
          onPrev();
          break;
        case 'ArrowRight':
          onNext();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onNext, onPrev]);

  if (!photo) return null;

  const imagePath = getImagePath(photo.imageName, 'full', folder);

  return (
    <Modal isOpen={true} onClose={onClose}>
      <div className="image-modal">
        <button className="modal-nav-btn prev" onClick={onPrev} aria-label="Previous image">
          ‹
        </button>

        <div className="image-container">
          <img src={imagePath} alt={photo.title} />
          <div className="image-info">
            <h2 className="image-title">{photo.title}</h2>
            <p className="image-date">{photo.date}</p>
          </div>
        </div>

        <button className="modal-nav-btn next" onClick={onNext} aria-label="Next image">
          ›
        </button>
      </div>
    </Modal>
  );
}

ImageModal.propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired
  }),
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  folder: PropTypes.string
};

export default ImageModal;
